import React from 'react';
import {
    getTld,
    isAllowedTld,
    SupportedTLD,
} from '../pricingAndPackagingUtils';

const CheckIcon: React.FC = () => {
    return (
        <img
            src="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/images/a-CheckIcon.svg"
            loading="lazy"
            alt="Check Icon"
            style={{ alignSelf: 'center' }}
        />
    );
};

const CrossIcon: React.FC = () => {
    return (
        <img
            src="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/images/a-CrossIcon.svg"
            loading="lazy"
            alt="Check Icon"
            style={{ alignSelf: 'center' }}
        />
    );
};

type ValueType = {
    value: React.ReactNode;
    highlight: boolean;
};

type PartnerData = {
    [category: string]: {
        [partner: string]: ValueType;
    };
};

export const partnerWithEventbriteForDotCom: PartnerData = {
    'Consumer audience reach<sup>1</sup>': {
        Eventbrite: {
            value: (
                <p className="c-competitors-grid__text is-sbold is-green-s">
                    93M
                </p>
            ),
            highlight: true,
        },
        eTix: {
            value: <p className="c-competitors-grid__text">20M</p>,
            highlight: false,
        },
        'See Tickets': {
            value: <p className="c-competitors-grid__text">15M</p>,
            highlight: false,
        },
        Dice: {
            value: <p className="c-competitors-grid__text">10M</p>,
            highlight: false,
        },
        Universe: {
            value: <p className="c-competitors-grid__text">5M</p>,
            highlight: false,
        },
    },
    'AI-powered tools': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        eTix: {
            value: <CrossIcon />,
            highlight: false,
        },
        'See Tickets': {
            value: <CrossIcon />,
            highlight: false,
        },
        Dice: {
            value: <CrossIcon />,
            highlight: false,
        },
        Universe: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
    'Email and social media ad tools with smart audiences': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        eTix: {
            value: <CrossIcon />,
            highlight: false,
        },
        'See Tickets': {
            value: <CrossIcon />,
            highlight: false,
        },
        Dice: {
            value: <CrossIcon />,
            highlight: false,
        },
        Universe: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
    'Advertise to ticket buyers on the platform': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        eTix: {
            value: <CrossIcon />,
            highlight: false,
        },
        'See Tickets': {
            value: <CrossIcon />,
            highlight: false,
        },
        Dice: {
            value: <CrossIcon />,
            highlight: false,
        },
        Universe: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
    'Self-service + Create an event in seconds': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        eTix: {
            value: <CrossIcon />,
            highlight: false,
        },
        'See Tickets': {
            value: <CrossIcon />,
            highlight: false,
        },
        Dice: {
            value: <CrossIcon />,
            highlight: false,
        },
        Universe: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
};

export const partnerWithEventbriteForDotAU: PartnerData = {
    'AI-powered tools': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        TryBooking: {
            value: <CrossIcon />,
            highlight: false,
        },
        Oztix: {
            value: <CrossIcon />,
            highlight: false,
        },
        Humanitix: {
            value: <CrossIcon />,
            highlight: false,
        },
        Moshtix: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
    'Email marketing & social media tools': {
        Eventbrite: {
            value: (
                <p
                    className="c-competitors-grid__text is-sbold is-green-s"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Built-in tools with smart audiences
                </p>
            ),
            highlight: true,
        },
        TryBooking: {
            value: (
                <p
                    className="c-competitors-grid__text"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Email only
                </p>
            ),
            highlight: false,
        },
        Oztix: {
            value: (
                <p
                    className="c-competitors-grid__text"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Email only
                </p>
            ),
            highlight: false,
        },
        Humanitix: {
            value: (
                <p
                    className="c-competitors-grid__text"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Email only
                </p>
            ),
            highlight: false,
        },
        Moshtix: {
            value: (
                <p
                    className="c-competitors-grid__text"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Email only
                </p>
            ),
            highlight: false,
        },
    },
    'Advertise to ticket buyers on the platform': {
        Eventbrite: {
            value: <CheckIcon />,
            highlight: true,
        },
        TryBooking: {
            value: <CrossIcon />,
            highlight: false,
        },
        Oztix: {
            value: <CrossIcon />,
            highlight: false,
        },
        Humanitix: {
            value: <CrossIcon />,
            highlight: false,
        },
        Moshtix: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
    'Industry-best payment technology': {
        Eventbrite: {
            value: (
                <p
                    className="c-competitors-grid__text is-sbold is-green-s"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Get paid before your event; secure processing for attendees
                </p>
            ),
            highlight: true,
        },
        TryBooking: {
            value: <CrossIcon />,
            highlight: false,
        },
        Oztix: {
            value: <CrossIcon />,
            highlight: false,
        },
        Humanitix: {
            value: (
                <p
                    className="c-competitors-grid__text"
                    style={{
                        textAlign: 'center',
                        fontSize: '13px',
                        alignSelf: 'center',
                    }}
                >
                    Payout before event only upon request
                </p>
            ),
            highlight: false,
        },
        Moshtix: {
            value: <CrossIcon />,
            highlight: false,
        },
    },
};

export const TLD_TO_COMPETITOR_DATA_MAP = {
    [SupportedTLD.Canada]: ['eTix', 'See Tickets', 'Dice', 'Universe'],
    [SupportedTLD.UnitedKingdom]: ['eTix', 'See Tickets', 'Dice', 'Universe'],
    [SupportedTLD.Ireland]: ['eTix', 'See Tickets', 'Dice', 'Universe'],
    [SupportedTLD.Australia]: ['TryBooking', 'Oztix', 'Humanitix', 'Moshtix'],
    [SupportedTLD.NewZealand]: ['TryBooking', 'Oztix', 'Humanitix', 'Moshtix'],
    [SupportedTLD.UnitedStates]: ['eTix', 'See Tickets', 'Dice', 'Universe'],
};

export const TLD_TO_PARTNER_DATA_MAP = {
    [SupportedTLD.Canada]: partnerWithEventbriteForDotCom,
    [SupportedTLD.UnitedKingdom]: partnerWithEventbriteForDotCom,
    [SupportedTLD.Ireland]: partnerWithEventbriteForDotCom,
    [SupportedTLD.Australia]: partnerWithEventbriteForDotAU,
    [SupportedTLD.NewZealand]: partnerWithEventbriteForDotAU,
    [SupportedTLD.UnitedStates]: partnerWithEventbriteForDotCom,
};

export const TLD_TO_DISCLAIMER_MAP = {
    [SupportedTLD.Canada]: true,
    [SupportedTLD.UnitedKingdom]: true,
    [SupportedTLD.Ireland]: true,
    [SupportedTLD.Australia]: false,
    [SupportedTLD.NewZealand]: false,
    [SupportedTLD.UnitedStates]: true,
};

export const getPartnerData = () => {
    if (isAllowedTld()) {
        const tld = getTld() as SupportedTLD;
        return TLD_TO_PARTNER_DATA_MAP[tld];
    } else {
        return partnerWithEventbriteForDotCom;
    }
};

export const getCompetitors = () => {
    if (isAllowedTld()) {
        const tld = getTld() as SupportedTLD;
        return TLD_TO_COMPETITOR_DATA_MAP[tld];
    } else {
        return ['eTix', 'See Tickets', 'Dice', 'Universe'];
    }
};

export const showDisclaimer = () => {
    if (isAllowedTld()) {
        const tld = getTld() as SupportedTLD;
        return TLD_TO_DISCLAIMER_MAP[tld];
    } else {
        return ['eTix', 'See Tickets', 'Dice', 'Universe'];
    }
};
